import React from 'react';
import { FormControlLabel, MenuItem, Switch, TextField, Typography } from '@material-ui/core';
import clsx from 'clsx';
import useStyles from 'app/cluster-styles/useStyles';
import SectionCard from '../components/SectionCard';

const TPU_ACCELERATOR_OPTIONS = [
    { value: 'v2-8', label: 'TPU v2-8' },
    { value: 'v2-32', label: 'TPU v2-32' },
    { value: 'v2-128', label: 'TPU v2-128' },
    { value: 'v2-256', label: 'TPU v2-256' },
    { value: 'v2-512', label: 'TPU v2-512' },
    { value: 'v3-8', label: 'TPU v3-8' },
    { value: 'v4-8', label: 'TPU v4-8' },
    { value: 'v5litepod-1', label: 'TPU v5e Lite Pod 1' },
    { value: 'v5litepod-4', label: 'TPU v5e Lite Pod 4' },
    { value: 'v5litepod-8', label: 'TPU v5e Lite Pod 8' },
    { value: 'v5p-8', label: 'TPU v5p 8' },
    { value: 'v6e-1', label: 'TPU v6e 1' },
];

const TPU_RUNTIME_OPTIONS = [
    { value: 'tpu-vm-tf-2.13.0', label: 'TensorFlow 2.13' },
    { value: 'tpu-vm-tf-2.14.0', label: 'TensorFlow 2.14' },
    { value: 'tpu-vm-pt-2.1', label: 'PyTorch 2.1' },
    { value: 'tpu-vm-tf-2.12.0', label: 'TensorFlow 2.12' },
];

export default function TpuSection({ form, setField }) {
    const classes = useStyles();

    return (
        <SectionCard icon="memory" title="TPU Compute Nodes">
            <div className="flex flex-row my-16 w-full items-center">
                <FormControlLabel
                    control={
                        <Switch
                            checked={form.tpuEnabled || false}
                            onChange={(e) => setField('tpuEnabled', e.target.checked)}
                            name="tpu_enabled"
                            color="primary"
                        />
                    }
                    label="Enable TPU"
                    labelPlacement="end"
                />
            </div>

            {form.tpuEnabled && (
                <>
                    <div className="flex flex-row my-16 w-full">
                        <TextField
                            select
                            className={clsx(classes.input, 'w-1/3 mr-8')}
                            label="Accelerator Type *"
                            variant="outlined"
                            value={form.tpuAcceleratorType || 'v2-8'}
                            onChange={(e) => setField('tpuAcceleratorType', e.target.value)}
                            required
                            SelectProps={{ MenuProps: { PaperProps: { style: { maxHeight: 300 } } } }}
                        >
                            {TPU_ACCELERATOR_OPTIONS.map(opt => (
                                <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
                            ))}
                        </TextField>

                        <TextField
                            select
                            className={clsx(classes.input, 'w-1/3 mr-8 ml-8')}
                            label="Runtime Version *"
                            variant="outlined"
                            value={form.tpuRuntimeVersion || 'tpu-vm-tf-2.13.0'}
                            onChange={(e) => setField('tpuRuntimeVersion', e.target.value)}
                            required
                            SelectProps={{ MenuProps: { PaperProps: { style: { maxHeight: 300 } } } }}
                        >
                            {TPU_RUNTIME_OPTIONS.map(opt => (
                                <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
                            ))}
                        </TextField>

                        <TextField
                            className={clsx(classes.input, 'w-1/3 ml-8')}
                            label="Number of TPU Nodes"
                            type="number"
                            variant="outlined"
                            value={form.tpuCount || 1}
                            onChange={(e) => setField('tpuCount', parseInt(e.target.value, 10) || 1)}
                            inputProps={{ min: 1, max: 100 }}
                        />
                    </div>

                    <div className="flex flex-row my-16 w-full">
                        <TextField
                            className={clsx(classes.input, 'w-full')}
                            label="CIDR Block (Optional - Auto-assigned if empty)"
                            variant="outlined"
                            value={form.tpuCidrBlock || ''}
                            onChange={(e) => setField('tpuCidrBlock', e.target.value || null)}
                            placeholder="e.g., 10.128.0.0/29"
                            helperText="Leave empty for automatic assignment (10.128+idx.0.0/29)"
                        />
                    </div>

                    <div className="flex flex-row my-16 w-full items-center">
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={form.tpuEnableExternalIps || false}
                                    onChange={(e) => setField('tpuEnableExternalIps', e.target.checked)}
                                    name="tpu_enable_external_ips"
                                    color="primary"
                                />
                            }
                            label="Enable External IPs"
                            labelPlacement="end"
                            className="mr-24"
                        />
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={form.tpuPreemptible || false}
                                    onChange={(e) => setField('tpuPreemptible', e.target.checked)}
                                    name="tpu_preemptible"
                                    color="primary"
                                />
                            }
                            label="Preemptible"
                            labelPlacement="end"
                            className="mr-24"
                        />
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={form.tpuSpot || false}
                                    onChange={(e) => setField('tpuSpot', e.target.checked)}
                                    name="tpu_spot"
                                    color="primary"
                                />
                            }
                            label="Spot"
                            labelPlacement="end"
                        />
                    </div>
                </>
            )}
        </SectionCard>
    );
}
